module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"ScheduleActivated":"","doctor":"ექიმი","telemedicine":"ონლაინ","visit":"კლინიკაში","house_call":"გამოძახება","experience":"წლის გამოცდილება"},"en":{"ScheduleActivated":"","doctor":"Doctor","telemedicine":"Online","visit":"At Clinic","house_call":"House Call","experience":"Years of Experience"}}')
  delete Component.options._Ctor
}
